import VolEnAttente from './VolEnAttente';
export default VolEnAttente;
